<template>
  <div class="breadcrumbs-wrapper">
    <div class="content-max-width">
      <nav aria-label="breadcrumb" class="breadcrumbs-container">
        <ol class="breadcrumbs">
          <li
            v-for="(item, index) in processedItems"
            :key="index"
            class="breadcrumb-item"
            :class="{ active: index === processedItems.length - 1 }"
          >
            <template v-if="index === processedItems.length - 1">
              <span>{{ item.name }}</span>
            </template>
            <template v-else>
              <a :href="item.url">{{ item.name }}</a>
            </template>
          </li>
        </ol>
      </nav>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    breadcrumbs: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  computed: {
    processedItems() {
      return this.breadcrumbs.map((item) => {
        return {
          name: item.name || "",
          url: item.url || "#",
        };
      });
    },
  },
};
</script>
